export enum NextContactDateReason {
  WorksForCompetitor = "WorksForCompetitor",
  PermanentEmployment = "PermanentEmployment",
  Other = "Other"
}
